import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from '@freelancer/auth';
import type { TypedAction } from '@freelancer/datastore/core';
import { isWebsocketAction } from '@freelancer/datastore/core';
import { toNumber } from '@freelancer/utils';
import { Actions, createEffect } from '@ngrx/effects';
import { combineLatest } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import type { ThreadsCollection } from './threads.types';

@Injectable()
export class ThreadsInboxSwapEffect {
  readonly effect$ = createEffect(
    () =>
      combineLatest([
        this.actions$.pipe(
          filter(action => isWebsocketAction<ThreadsCollection>(action)),
        ),
        this.auth.getUserId().pipe(map(toNumber)),
      ]).pipe(
        tap(([{ payload }, authUid]) => {
          // check if user was removed from thread
          if (
            payload.type === 'groupchat' &&
            payload.data.action === 'remove' &&
            authUid &&
            payload.data.payload.members.includes(authUid)
          ) {
            // clear inbox thread if we're in inbox
            if (this.router.url.startsWith('/messages')) {
              this.router.navigate(['/messages']);
            }
          }
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions<TypedAction>,
    private auth: Auth,
    private router: Router,
  ) {}
}
